/* ============
 * State of cvc module
 * ============
 *
 * The initial state of the cvc module.
 */

export default {
  user: null,
  cvcParams: null
}



// WEBPACK FOOTER //
// ./src/store/modules/cvc/state.js